import { ReactElement } from "react";
import { Stack, useTheme, useMediaQuery } from "@mui/material";
import { Text } from "./Text";

type Props = {
  title?: string;
  children: ReactElement;
};

export const Parentheses = ({ title, children }: Props) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  return (
    <Stack position="relative" padding={isMobile ? 2 : 3}>
      <Stack
        position="absolute"
        top={0}
        left={0}
        width={isMobile ? 12 : 25}
        height={isMobile ? 12 : 25}
      >
        <img src="/images/parentheses.svg" alt="" />
      </Stack>
      {title ? (
        <Text variant="h2" color="primary">
          {title}
        </Text>
      ) : null}
      {children}
      <Stack
        position="absolute"
        bottom={0}
        right={0}
        width={isMobile ? 12 : 25}
        height={isMobile ? 12 : 25}
        sx={{
          transform: "rotate(180deg)",
        }}
      >
        <img src="/images/parentheses.svg" alt="" />
      </Stack>
    </Stack>
  );
};
